module.exports = __webpack_public_path__ + "img/close-circle-search-active.05004fdd.svg";